import { AddressFieldType, AddressKey } from "./types";
import { Address } from "../../models";

export const DEFAULT_ADDRESS: Address = {
  countyId: undefined,
  county: "",
  municipalityId: undefined,
  municipality: "",
  town: "",
  townId: undefined,
  street: "",
  streetId: undefined,
  houseNumber: "",
  houseNumberId: undefined,
};

const STREET_KEYS: AddressKey[] = ["streetId", "street"];
const HOUSE_NUMBER_KEYS: AddressKey[] = ["houseNumberId", "houseNumber"];
const MUNICIPALITY_KEYS: AddressKey[] = ["municipalityId", "municipality"];
const TOWN_KEYS: AddressKey[] = ["townId", "town"];

export const DEPENDENT_FIELDS_MAP: Record<AddressFieldType, AddressKey[]> = {
  county: [
    ...MUNICIPALITY_KEYS,
    ...TOWN_KEYS,
    ...STREET_KEYS,
    ...HOUSE_NUMBER_KEYS,
  ],
  municipality: [...TOWN_KEYS, ...STREET_KEYS, ...HOUSE_NUMBER_KEYS],
  town: [...STREET_KEYS, ...HOUSE_NUMBER_KEYS],
  street: [...HOUSE_NUMBER_KEYS],
  houseNumber: [],
};
